import { mediaUrl } from "@/lib/api";

function ytId(url = "") {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/);
  return m ? m[1] : null;
}
function vimeoId(url = "") {
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}

export default function MediaBlock({ block }) {
  if (!block?.url) return null;
  const wrap = block.full_width ? "w-full" : "mx-auto max-w-[1400px] px-6 md:px-12";
  const yt = ytId(block.url), vm = vimeoId(block.url);
  const params = `autoplay=${block.autoplay ? 1 : 0}&mute=${block.muted !== false ? 1 : 0}&loop=${block.loop ? 1 : 0}&controls=0&playsinline=1`;

  return (
    <section className={`${block.full_width ? "" : "py-8"} border-b hairline`} data-testid={`media-block-${block.id}`}>
      <div className={wrap}>
        <div className="relative w-full aspect-video bg-cream overflow-hidden">
          {block.media_type === "image" ? (
            <img src={mediaUrl(block.url)} alt={block.headline || ""} className="w-full h-full object-cover" />
          ) : yt ? (
            <iframe title="media" className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${yt}?${params}&playlist=${yt}`} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
          ) : vm ? (
            <iframe title="media" className="absolute inset-0 w-full h-full" src={`https://player.vimeo.com/video/${vm}?background=${block.autoplay ? 1 : 0}&muted=${block.muted !== false ? 1 : 0}&loop=${block.loop ? 1 : 0}`} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />
          ) : (
            <video src={mediaUrl(block.url)} className="w-full h-full object-cover" autoPlay={block.autoplay} muted={block.muted !== false} loop={block.loop} playsInline controls={!block.autoplay} />
          )}
          {block.headline && (
            <div className="absolute inset-0 flex items-center justify-center bg-ink/20">
              <h3 className="font-heading text-3xl md:text-5xl text-linen text-center px-6">{block.headline}</h3>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
